// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.inputLabel[data-v-3c4f4df9] {\n  padding: 15px;\n}\n.input[data-v-3c4f4df9] {\n  display: inline-block;\n  width: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
